import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Project Ideas",
    date: "26 May, 2025",
    admin: "Admin",
    heading: "Renovating Your Kitchen Cabinets: Before And After",
    important: {
      content: "Renovating your kitchen cabinets can drastically improve the look and feel of your entire home. With careful planning and execution, you can achieve stunning results that will impress for years to come.",
      intro: "Interior Designer"
    },
    paragraph: {
      para1: "Transform your kitchen space with stunning before and after images of cabinet renovations. Discover how simple updates can breathe new life into your kitchen and enhance its functionality.",
      para2: "From fresh paint and hardware replacements to complete cabinet overhauls, these inspiring transformations showcase the power of kitchen cabinet renovation. Get inspired and start planning your kitchen makeover today!",
      para3: "Explore the possibilities of kitchen cabinet renovation and learn valuable tips for maximizing your budget and achieving your desired aesthetic. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the potential of your kitchen space with these stunning before and after images. Let these transformations inspire your own kitchen renovation journey! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Renovation", "Kitchen", "Decor"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "04 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "05 Feb, 2025",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "05 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: []
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "DIY Tutorials",
    date: "10 May, 2025",
    admin: "Admin",
    heading: "Mastering Basic Woodworking Joints",
    important: {
      content: "Understanding the fundamentals of woodworking joints is essential for building strong, lasting furniture. Whether you're a hobbyist or a beginner, mastering these joints will elevate your craftsmanship.",
      intro: "Workshop Instructor"
    },
    paragraph: {
      para1: "Woodworking joints are the backbone of any carpentry project. Learning how to create clean, precise joints allows for stronger and more professional-looking results.",
      para2: "In this guide, we’ll explore essential joints such as butt joints, dovetail joints, mortise and tenon, and more. You'll understand when and why to use each type depending on your project needs.",
      para3: "With the right tools and techniques, even beginner woodworkers can master these foundational skills. Practice and patience are key to achieving clean fits and strong bonds.",
      para4: "Start simple, and gradually work your way up to more complex joinery. Whether you're building shelves, frames, or furniture, mastering joints gives your projects strength and style."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Woodworking", "Tools", "Furniture"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Laura Mitchell",
        date: "12 Mar, 2025",
        content: "Great overview! I’ve been struggling with clean dovetails, but this gave me the motivation to keep practicing.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Tom Richards",
            date: "13 Mar, 2025",
            content: "Same here — I recommend a dovetail jig for beginners. Made a big difference for me!"
          }
        ]
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Design Trends",
    date: "18 May, 2025",
    admin: "Admin",
    heading: "The Rise of Minimalist Wood Furniture",
    important: {
      content: "Minimalist wood furniture is redefining modern interiors by emphasizing clean lines, natural textures, and functional beauty. It’s a return to simplicity — where less truly becomes more.",
      intro: "Furniture Design Specialist"
    },
    paragraph: {
      para1: "In an age of visual clutter and digital overload, minimalist wood furniture offers a calming and grounded aesthetic. Its rise in popularity reflects a broader movement toward intentional living and timeless design.",
      para2: "Characterized by neutral tones, exposed grain, and sleek silhouettes, minimalist wood pieces fit effortlessly into any space — from urban lofts to cozy cottages.",
      para3: "Designers are increasingly favoring sustainable woods, like oak, walnut, and ash, to create furniture that feels warm and organic without overwhelming the senses.",
      para4: "Minimalist furniture isn't about sacrificing comfort or function; it's about celebrating materials and craftsmanship in their purest forms. This trend continues to inspire both new homeowners and seasoned designers alike."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Minimalist", "Furniture", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Ava Thompson",
        date: "20 Apr, 2025",
        content: "This is exactly my aesthetic! Love the balance of simplicity and warmth.",
        replies: []
      },
      {
        id: 2,
        image: images.blog3Comment2,
        name: "Jordan Lee",
        date: "21 Apr, 2025",
        content: "Minimalist wood furniture is definitely timeless — thanks for the great read!",
        replies: []
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Tool Guides",
    date: "02 May, 2025",
    admin: "Admin",
    heading: "Essential Tools Every Woodworker Should Own",
    important: {
      content: "Whether you're just starting or refining your workshop, having the right tools is key to successful woodworking. Invest wisely in quality basics that will last a lifetime.",
      intro: "Tool Expert"
    },
    paragraph: {
      para1: "Building a woodworking toolkit can feel overwhelming, but focusing on the essentials ensures you're ready for most projects without breaking the bank.",
      para2: "This guide covers must-have tools like a quality tape measure, combination square, chisels, hand saws, and cordless drills. These tools form the foundation of any well-equipped workshop.",
      para3: "We also highlight power tools such as the circular saw, orbital sander, and table saw — which boost efficiency and precision for both beginner and advanced woodworkers.",
      para4: "Whether you're crafting furniture, cabinetry, or simple DIY projects, the right tools make all the difference in safety, accuracy, and finish quality."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Tools", "Woodworking", "Renovation"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Ethan Brooks",
        date: "03 May, 2025",
        content: "Fantastic list! I just got into woodworking and this helped me prioritize what to buy.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Sophie Green",
            date: "04 May, 2025",
            content: "Same here — the tip about getting quality over quantity is so true. Thanks!"
          }
        ]
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Home Decor",
    date: "15 Apr, 2025",
    admin: "Admin",
    heading: "Stunning Woodwork Furniture to Elevate Your Home Decor",
    important: {
      content: "Well-crafted wood furniture can instantly elevate the look and feel of your home. From rustic coffee tables to custom shelving, discover how timeless pieces bring warmth and sophistication to any space.",
      intro: "Interior Stylist"
    },
    paragraph: {
      para1: "Woodwork furniture isn’t just functional — it’s a statement. Each piece brings character, craftsmanship, and natural texture into your home.",
      para2: "This article highlights standout pieces like handcrafted dining tables, minimalist bed frames, and artistic accent chairs that blend seamlessly with various décor styles.",
      para3: "Whether you love traditional, contemporary, or boho aesthetics, there’s a wooden design to complement your space and reflect your personal taste.",
      para4: "Let these stunning woodwork inspirations guide your next home upgrade. Choose pieces that are both beautiful and built to last."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Furniture", "Decor", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Grace Nolan",
        date: "16 May, 2025",
        content: "I love how wood can make a space feel so cozy and refined at the same time!",
        replies: []
      },
      {
        id: 2,
        image: images.blog5Comment2,
        name: "Daniel Ruiz",
        date: "17 May, 2025",
        content: "This gave me great ideas for our new living room. Can’t wait to start redecorating.",
        replies: []
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Project Ideas",
    date: "28 Apr, 2025",
    admin: "Admin",
    heading: "Ideas for Building Beautiful Outdoor Structures",
    important: {
      content: "Outdoor structures like pergolas, decks, and garden benches not only enhance your yard’s functionality but also create inviting spaces to relax and entertain. With the right plan and craftsmanship, your outdoor area can become a true extension of your home.",
      intro: "Landscape Carpenter"
    },
    paragraph: {
      para1: "Transform your backyard with custom-built structures that offer both style and purpose. From shaded pergolas to multi-level decks, the possibilities are endless.",
      para2: "This guide offers ideas for projects such as wooden gazebos, planter walls, outdoor kitchens, and even treehouse platforms — each tailored to boost your outdoor experience.",
      para3: "We also discuss key considerations like wood durability, weatherproofing techniques, and layout optimization to ensure your structure lasts through every season.",
      para4: "Whether you're a DIY enthusiast or planning to hire a pro, these ideas will help you create outdoor spaces that are both beautiful and built to last."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Outdoor", "Renovation", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Liam Carter",
        date: "29 May, 2025",
        content: "We just finished a pergola build — wish I’d seen this post earlier! Great ideas here.",
        replies: []
      },
      {
        id: 2,
        image: images.blog6Comment2,
        name: "Nora Jennings",
        date: "30 May, 2025",
        content: "Love the planter wall suggestion. Definitely adding it to my summer project list!",
        replies: []
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Project Ideas",
    date: "22 Apr, 2025",
    admin: "Admin",
    heading: "Transforming Your Kitchen Cabinets: Before & After",
    important: {
      content: "Renovating your kitchen cabinets can drastically improve the look and feel of your entire home. With careful planning and execution, you can achieve stunning results that will impress for years to come.",
      intro: "Interior Designer"
    },
    paragraph: {
      para1: "Transform your kitchen space with stunning before and after images of cabinet renovations. Discover how simple updates can breathe new life into your kitchen and enhance its functionality.",
      para2: "From fresh paint and hardware replacements to complete cabinet overhauls, these inspiring transformations showcase the power of kitchen cabinet renovation. Get inspired and start planning your kitchen makeover today!",
      para3: "Explore the possibilities of kitchen cabinet renovation and learn valuable tips for maximizing your budget and achieving your desired aesthetic. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the potential of your kitchen space with these stunning before and after images. Let these transformations inspire your own kitchen renovation journey! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Renovation", "Kitchen", "Decor"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Benjamin Alexander",
        date: "04 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Isabella Grace",
            date: "05 Feb, 2025",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Samuel James",
        date: "05 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: []
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "DIY Tutorials",
    date: "05 Apr, 2025",
    admin: "Admin",
    heading: "A Guide to Fundamental Woodworking Joints",
    important: {
      content: "Learning the core woodworking joints is crucial for building strong, functional, and beautiful wood projects. Mastering these basics opens the door to more advanced craftsmanship.",
      intro: "Woodshop Mentor"
    },
    paragraph: {
      para1: "Whether you're crafting a table, frame, or bookshelf, the quality of your joints will determine both strength and appearance. This guide introduces you to essential joints used in woodworking.",
      para2: "We cover everything from butt joints and lap joints to more complex options like dovetail and mortise & tenon. Each has unique advantages based on use case and skill level.",
      para3: "You'll also find practical tips on cutting techniques, using jigs for precision, and choosing the right adhesive or fasteners for lasting durability.",
      para4: "By understanding these foundational joints, you’ll build more confidently and produce results that are both sturdy and visually appealing."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Woodworking", "Tools", "Furniture"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Carla Jensen",
        date: "06 Jun, 2025",
        content: "This was super helpful! I've been struggling with joint accuracy, and your tips made it clearer.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Mark Eldridge",
            date: "07 Jun, 2025",
            content: "Practice really does make perfect with joinery. Keep at it!"
          }
        ]
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Design Trends",
    date: "12 Mar, 2025",
    admin: "Admin",
    heading: "The Growing Popularity of Minimalist Wooden Furniture",
    important: {
      content: "Minimalist wooden furniture continues to gain traction for its clean design, natural textures, and timeless appeal. Its blend of simplicity and function is transforming modern interiors worldwide.",
      intro: "Furniture Trend Analyst"
    },
    paragraph: {
      para1: "Driven by a desire for simplicity and calm in everyday living spaces, minimalist wooden furniture is becoming a staple in modern home design.",
      para2: "These pieces focus on natural wood finishes, straight lines, and open space — avoiding ornate details in favor of understated elegance.",
      para3: "Homeowners and designers are choosing sustainably sourced woods and handcrafted pieces to reflect authenticity, durability, and eco-conscious values.",
      para4: "Whether it’s a Scandinavian-inspired bench or a sleek oak dining table, minimalist wooden furniture enhances your space with warmth, functionality, and style that endures."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Minimalist", "Furniture", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Sophia Delgado",
        date: "13 Jun, 2025",
        content: "Minimalist design with wood is such a beautiful combo. I’ve slowly started replacing my furniture with simpler, wooden pieces.",
        replies: []
      },
      {
        id: 2,
        image: images.blog9Comment2,
        name: "Michael Tao",
        date: "14 Jun, 2025",
        content: "I used to prefer industrial style, but minimalist wood furniture really changed my perspective. Great read!",
        replies: []
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Tool Guides",
    date: "20 Mar, 2025",
    admin: "Admin",
    heading: "Must-Have Tools for Every Woodworker",
    important: {
      content: "Every successful woodworking project starts with the right tools. Whether you're a beginner or a seasoned craftsman, a solid toolkit is the backbone of your workshop.",
      intro: "Workshop Pro"
    },
    paragraph: {
      para1: "Woodworking requires precision, creativity, and most importantly — the right set of tools. Without them, even the best ideas are hard to bring to life.",
      para2: "This guide walks you through must-have hand tools like chisels, clamps, measuring squares, and mallets, as well as power tools such as circular saws, routers, and jigsaws.",
      para3: "We also touch on essential safety equipment, including hearing protection, dust masks, and eye protection — critical for both hobbyists and professionals.",
      para4: "Equipping your workshop with these tools will empower you to tackle a wide range of woodworking projects with confidence, efficiency, and accuracy."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Tools", "Woodworking", "Renovation"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Noah Franklin",
        date: "21 Jun, 2025",
        content: "I just set up my first garage workshop — this list helped me prioritize my tool purchases!",
        replies: []
      },
      {
        id: 2,
        image: images.blog10Comment2,
        name: "Emily Rhodes",
        date: "22 Jun, 2025",
        content: "Great reminder about safety gear. Often overlooked but so important.",
        replies: []
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Home Decor",
    date: "28 Mar, 2025",
    admin: "Admin",
    heading: "Beautiful Wooden Furniture to Enhance Your Home Decor",
    important: {
      content: "Incorporating beautiful wooden furniture into your home adds warmth, texture, and timeless charm. Discover how wood pieces can elevate the ambiance of any room.",
      intro: "Decor Expert"
    },
    paragraph: {
      para1: "Wooden furniture offers a unique blend of natural beauty and durability, making it a perfect choice for enhancing your living spaces.",
      para2: "From rustic coffee tables to sleek mid-century modern chairs, wooden pieces bring character and functionality to every corner of your home.",
      para3: "Choosing the right wood type, finish, and style can complement your existing decor while adding a touch of elegance.",
      para4: "Whether handcrafted or factory-made, well-selected wooden furniture transforms rooms into inviting, stylish environments."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["Furniture", "Decor", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Olivia Martin",
        date: "29 Jun, 2025",
        content: "I love how wooden furniture can instantly warm up a space. Great article!",
        replies: []
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Project Ideas",
    date: "05 Mar, 2025",
    admin: "Admin",
    heading: "Creative Ideas for Building Gorgeous Outdoor Structures",
    important: {
      content: "Transform your outdoor space with stunning structures that blend beauty and functionality. From pergolas to garden sheds, discover inspiring ideas to elevate your backyard.",
      intro: "Outdoor Design Specialist"
    },
    paragraph: {
      para1: "Outdoor structures add charm and usability to your yard, creating spaces for relaxation, entertainment, and gardening.",
      para2: "This guide covers creative ideas ranging from minimalist pergolas to cozy gazebos, customized decks, and practical garden sheds.",
      para3: "Learn about design considerations, materials, and tips for blending these structures seamlessly with your landscape.",
      para4: "Whether you’re a DIY enthusiast or planning professional help, these ideas will help you craft an inviting and functional outdoor retreat."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Outdoor", "Garden", "Woodworking"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Ethan Parker",
        date: "06 Jul, 2025",
        content: "Perfect timing for my backyard project! These ideas are inspiring.",
        replies: []
      }
    ]
  }
];

export default blogs;